import {
  FleetDeploymentsResponse,
  isFleetDeploymentsResponse,
} from '@internal/backstage-plugin-release-common';
import { ReleaseReadState, useReleaseRead } from './useReleaseRead';

export type FleetDeploymentsState = ReleaseReadState<FleetDeploymentsResponse>;

/**
 * Reads deployed image tags from the `release` backend.
 *
 * Both cards ask the same endpoint and differ only in the query: one service
 * for the component page, a whole system for the fleet page. Loading and
 * error states belong to whichever card is rendering, so neither can gate the
 * other.
 */
export function useFleetDeployments(
  query: { service: string } | { system: string },
): FleetDeploymentsState {
  const search =
    'service' in query
      ? `service=${encodeURIComponent(query.service)}`
      : `system=${encodeURIComponent(query.system)}`;

  return useReleaseRead({
    route: 'deployments',
    search,
    isResponse: isFleetDeploymentsResponse,
    shape: 'Deployments',
  });
}
